import { render, staticRenderFns } from "./ywgzgl.vue?vue&type=template&id=9ec64836&scoped=true&"
import script from "./ywgzgl.vue?vue&type=script&lang=js&"
export * from "./ywgzgl.vue?vue&type=script&lang=js&"
import style0 from "./ywgzgl.vue?vue&type=style&index=0&id=9ec64836&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec64836",
  null
  
)

export default component.exports